var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.592,
    height: 12.906,
    viewBox: "0 0 88.592 12.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(-7.336 -5.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56",
    transform: "translate(25.134 8.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M3.439-16.143a.767.767,0,0,1-.571-.217.78.78,0,0,1-.212-.571v-7.151a.764.764,0,0,1,.212-.565.78.78,0,0,1,.571-.212.78.78,0,0,1,.576.212.764.764,0,0,1,.212.565v7.151a.78.78,0,0,1-.212.571A.767.767,0,0,1,3.439-16.143Zm0,0",
    transform: "translate(-2.656 24.859)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(28.555 8.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M9.161-24.859a.714.714,0,0,1,.543.212.792.792,0,0,1,.2.565v7.151a.793.793,0,0,1-.206.571.709.709,0,0,1-.538.217.7.7,0,0,1-.6-.277L4.118-22.208v5.277a.817.817,0,0,1-.2.571.67.67,0,0,1-.533.217.686.686,0,0,1-.538-.217.817.817,0,0,1-.2-.571v-7.151a.772.772,0,0,1,.206-.565.741.741,0,0,1,.549-.212A.691.691,0,0,1,4-24.582l4.434,5.76v-5.26a.786.786,0,0,1,.2-.565A.692.692,0,0,1,9.161-24.859Zm0,0",
    transform: "translate(-2.656 24.859)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(37.216 8.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M4.813-16.2a6.183,6.183,0,0,1-1.772-.25,3.947,3.947,0,0,1-1.359-.674.687.687,0,0,1-.277-.587.67.67,0,0,1,.152-.44.448.448,0,0,1,.359-.19,1.022,1.022,0,0,1,.5.168,3.53,3.53,0,0,0,1.092.549,4.475,4.475,0,0,0,1.266.168,2.493,2.493,0,0,0,1.364-.31,1.014,1.014,0,0,0,.478-.908.783.783,0,0,0-.446-.712,5.889,5.889,0,0,0-1.478-.478A8.809,8.809,0,0,1,2.95-20.4a2.475,2.475,0,0,1-1.011-.777A2.017,2.017,0,0,1,1.6-22.381a2.286,2.286,0,0,1,.424-1.353,2.8,2.8,0,0,1,1.19-.929A4.189,4.189,0,0,1,4.922-25a4.245,4.245,0,0,1,2.837.924.876.876,0,0,1,.228.266.694.694,0,0,1,.065.321.7.7,0,0,1-.152.446.453.453,0,0,1-.359.185.73.73,0,0,1-.223-.033,1.912,1.912,0,0,1-.277-.136,4.172,4.172,0,0,0-.967-.538,3.236,3.236,0,0,0-1.152-.179,2.256,2.256,0,0,0-1.31.337,1.067,1.067,0,0,0-.478.929.851.851,0,0,0,.424.766,5.059,5.059,0,0,0,1.451.5,9.821,9.821,0,0,1,1.755.543,2.626,2.626,0,0,1,1.038.761,1.832,1.832,0,0,1,.359,1.157,2.206,2.206,0,0,1-.418,1.331,2.762,2.762,0,0,1-1.179.9A4.487,4.487,0,0,1,4.813-16.2Zm0,0",
    transform: "translate(-1.406 25)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(45.37 8.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M6.108-16.1a3.641,3.641,0,0,1-2.679-.913,3.614,3.614,0,0,1-.913-2.668v-4.4a.772.772,0,0,1,.207-.565.762.762,0,0,1,.565-.212.747.747,0,0,1,.56.212.778.778,0,0,1,.206.565V-19.6a2.388,2.388,0,0,0,.522,1.674,1.98,1.98,0,0,0,1.532.565,1.96,1.96,0,0,0,1.522-.571A2.379,2.379,0,0,0,8.156-19.6v-4.483a.772.772,0,0,1,.206-.565.743.743,0,0,1,.56-.212.748.748,0,0,1,.56.212.778.778,0,0,1,.206.565v4.4a3.618,3.618,0,0,1-.913,2.663A3.6,3.6,0,0,1,6.108-16.1Zm0,0",
    transform: "translate(-2.516 24.859)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(54.344 8.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M9.525-17.09a.787.787,0,0,1,.147.429.57.57,0,0,1-.228.462.807.807,0,0,1-.527.185.814.814,0,0,1-.375-.092.772.772,0,0,1-.293-.277L6.629-18.84a1.569,1.569,0,0,0-.522-.549,1.406,1.406,0,0,0-.706-.158h-1.2v2.728A.791.791,0,0,1,4-16.243a.748.748,0,0,1-.56.212.78.78,0,0,1-.571-.212.778.778,0,0,1-.212-.576v-7.124a.729.729,0,0,1,.2-.549.758.758,0,0,1,.554-.2H6.46a3.322,3.322,0,0,1,2.217.652,2.334,2.334,0,0,1,.766,1.88,2.374,2.374,0,0,1-.571,1.641,2.693,2.693,0,0,1-1.6.821,1.576,1.576,0,0,1,.62.3,2.7,2.7,0,0,1,.522.609ZM6.237-20.753a2.077,2.077,0,0,0,1.3-.331,1.255,1.255,0,0,0,.413-1.033,1.224,1.224,0,0,0-.413-1.027,2.105,2.105,0,0,0-1.3-.326H4.194v2.717Zm0,0",
    transform: "translate(-2.656 24.688)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66",
    transform: "translate(62.807 8.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M3.412-16.1a.758.758,0,0,1-.554-.2.727.727,0,0,1-.2-.549v-7.1a.729.729,0,0,1,.2-.549.758.758,0,0,1,.554-.2h4.4a.857.857,0,0,1,.549.158.547.547,0,0,1,.2.451.588.588,0,0,1-.2.473.834.834,0,0,1-.549.163H4.194v2.358H7.563a.835.835,0,0,1,.549.163.56.56,0,0,1,.2.462.545.545,0,0,1-.2.451.849.849,0,0,1-.549.158H4.194v2.505H7.808a.821.821,0,0,1,.549.168.575.575,0,0,1,.2.467.545.545,0,0,1-.2.451.849.849,0,0,1-.549.158Zm0,0",
    transform: "translate(-2.656 24.688)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(69.977 8.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M9.525-17.09a.787.787,0,0,1,.147.429.57.57,0,0,1-.228.462.807.807,0,0,1-.527.185.814.814,0,0,1-.375-.092.772.772,0,0,1-.293-.277L6.629-18.84a1.569,1.569,0,0,0-.522-.549,1.406,1.406,0,0,0-.706-.158h-1.2v2.728A.791.791,0,0,1,4-16.243a.748.748,0,0,1-.56.212.78.78,0,0,1-.571-.212.778.778,0,0,1-.212-.576v-7.124a.729.729,0,0,1,.2-.549.758.758,0,0,1,.554-.2H6.46a3.322,3.322,0,0,1,2.217.652,2.334,2.334,0,0,1,.766,1.88,2.374,2.374,0,0,1-.571,1.641,2.693,2.693,0,0,1-1.6.821,1.576,1.576,0,0,1,.62.3,2.7,2.7,0,0,1,.522.609ZM6.237-20.753a2.077,2.077,0,0,0,1.3-.331,1.255,1.255,0,0,0,.413-1.033,1.224,1.224,0,0,0-.413-1.027,2.105,2.105,0,0,0-1.3-.326H4.194v2.717Zm0,0",
    transform: "translate(-2.656 24.688)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(78.44 8.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M3.439-16.143a.767.767,0,0,1-.571-.217.78.78,0,0,1-.212-.571v-7.151a.764.764,0,0,1,.212-.565.78.78,0,0,1,.571-.212.78.78,0,0,1,.576.212.764.764,0,0,1,.212.565v7.151a.78.78,0,0,1-.212.571A.767.767,0,0,1,3.439-16.143Zm0,0",
    transform: "translate(-2.656 24.859)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(80.938 8.204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M3.739-16.042a.8.8,0,0,1-.581-.212.762.762,0,0,1-.212-.565v-6.575H.728c-.486,0-.728-.215-.728-.647s.242-.647.728-.647h6q.734,0,.734.647c0,.432-.245.647-.734.647H4.516v6.575a.762.762,0,0,1-.212.565A.764.764,0,0,1,3.739-16.042Zm0,0",
    transform: "translate(0 24.688)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(88.461 8.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M6.394-24.593a.67.67,0,0,1,.527-.266.69.69,0,0,1,.495.212.675.675,0,0,1,.223.505.706.706,0,0,1-.185.462L4.693-20.306v3.375a.755.755,0,0,1-.223.581.782.782,0,0,1-.56.206.793.793,0,0,1-.571-.206.761.761,0,0,1-.217-.581v-3.375L.357-23.68a.7.7,0,0,1-.185-.462.68.68,0,0,1,.217-.505.707.707,0,0,1,.5-.212.673.673,0,0,1,.527.266L3.911-21.5Zm0,0",
    transform: "translate(-0.172 24.859)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M7.336,5.828h2.716v12.9H7.336Zm0,0",
    transform: "translate(0 -0.003)",
    fill: "#f91212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M22.536,5.824V8.541H9.637V5.824Zm0,0",
    transform: "translate(-1.501 0)",
    fill: "#f91212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M20.219,17.152H26.8v6.133H20.219Zm0,0",
    transform: "translate(-8.402 -7.388)",
    fill: "#ff8200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M29.172,37.375v1.933H20.207V37.375Zm0,0",
    transform: "translate(-8.395 -20.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M41.184,17.152h1.933v8.965H41.184Zm0,0",
    transform: "translate(-22.076 -7.388)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d16baaf05c328791533af87214527f70.svg";
export { ForwardRef as ReactComponent };